import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close.svg";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import Spinner from "react-bootstrap/Spinner";

function PickupLocationModal({
  setShowPickupLocationModal,
  show,
  pickupLocations,
  setPracticeLocation,
  shareQuotation,
  modalLoading,
}) {
  const [fieldValue, setFieldValue] = useState(null);

  useEffect(() => {
    if (pickupLocations?.length === 1) {
      setFieldValue(pickupLocations[0]);
      setPracticeLocation({
        type: "PracticeLocation",
        id: pickupLocations[0].value,
      });
    }
  }, [show, pickupLocations]);

  const handlePickupLocationChange = (selectedPickupLocation) => {
    setFieldValue(selectedPickupLocation);

    if (selectedPickupLocation) {
      if (selectedPickupLocation.__isNew__) {
        setPracticeLocation({
          type: "DoctorChatInfoClinic",
          id: null,
          name: selectedPickupLocation.value,
        });
      } else {
        setPracticeLocation({
          type: "Location",
          id: selectedPickupLocation.value,
        });
      }
    } else {
      setPracticeLocation(
        JSON.parse(localStorage.getItem("practice_location"))
      );
    }
  };

  const confirmAndShare = () => {
    if (fieldValue) {
      shareQuotation();
    } else {
      alert("Please enter a branch before proceeding.");
    }
  };

  const Option = (props) => (
    <components.Option {...props}>
      <div className="dropdown-option">
        <div className="title">{props.data.label}</div>
        <div className="description">{props.data.description}</div>
      </div>
    </components.Option>
  );

  return (
    <Modal
      className="pickup-location-modal"
      size="lg"
      show={show}
      onHide={() => setShowPickupLocationModal(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <button
          type="button"
          className="close"
          onClick={() => setShowPickupLocationModal(false)}
        >
          <img src={CloseBtn} alt="modal-close" />
        </button>
      </Modal.Header>
      {modalLoading ? (
        <div className="loader">
          <Spinner animation="border" className="spinner" />
        </div>
      ) : (
        <>
          <Modal.Body>
            <h4>Select Pickup Location</h4>
            <p>
              Choose where the rider will pick up your order. Please note that
              the location can't be changed after confirmation.
            </p>
            <CreatableSelect
              formatCreateLabel={() => undefined}
              className="pickup-location-field"
              options={pickupLocations || undefined}
              placeholder="Please select branch"
              onChange={handlePickupLocationChange}
              isValidNewOption={() => false}
              components={{ Option }}
              defaultValue={
                pickupLocations?.length === 1 ? pickupLocations[0] : null
              }
              isClearable
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn w-100 confirm-pickup-location-btn"
              onClick={confirmAndShare}
            >
              Confirm Address & Approve Request
            </button>
            <button
              className="btn w-100 cancel-btn"
              onClick={() => setShowPickupLocationModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}

export default PickupLocationModal;
